
import {useState, useEffect } from 'react';
import { visualizerActions } from "../../store";
import { useSelector,useDispatch } from 'react-redux';
import FlooringSubMenu from "../FlooringSubMenu/FlooringSubMenu";
import { SERIES_IDS } from '../../Helpers/SeriesHelper';
import styles from './FlooringMenu.module.css';
export default function FlooringMenu() {
    const dispatch = useDispatch();
    const activeSubMenuTab = useSelector((state) => state.visualizer.activeFlooringSubMenuTab);
    const colorwaySeriesIds = useSelector((state) => state.visualizer.activeFlooringSeriesIds);

    const handleSubMenuTabSelect = (menuTab,seriesIds) => () => {
        dispatch(visualizerActions.clearProductDropdownFilters([]));
        dispatch(visualizerActions.setActiveFlooringSubMenuTab(menuTab));
        dispatch(visualizerActions.setActiveFlooringSeriesIds(seriesIds));
        
    };

    const handleSubMenuBack = function() {
        dispatch(visualizerActions.setActiveFlooringSubMenuTab(null));
    };

    const renderActiveSubMenuTab = (activeSubMenuTab,colorwaySeriesIds) => {
        return (
              <FlooringSubMenu
                activeParentMenuTab={activeSubMenuTab}
                colorwaySeriesIds={colorwaySeriesIds}
              />
            );
      };
    
    return (
        <>
            {activeSubMenuTab === null ? (
            <>
              <h4>Pick a product type</h4>
              <p>Select from the product types below to see all products, sizes, and installation methods offered.</p>
              <ul className={styles.mainMenu}>
                  <li><button type="button" onClick={handleSubMenuTabSelect('Modular Carpet',[SERIES_IDS.carpet])}>Modular Carpet <span>&#8250;</span></button></li>
                  <li><button type="button" onClick={handleSubMenuTabSelect('Broadloom Carpet',[SERIES_IDS.broadloom])}>Broadloom Carpet<span>&#8250;</span></button></li>
                  <li><button type="button" onClick={handleSubMenuTabSelect('LVT',[SERIES_IDS.lvt])}>LVT<span>&#8250;</span></button></li>
                  <li><button type="button" onClick={handleSubMenuTabSelect('Resilient Sheet',[SERIES_IDS.heterogeneous,SERIES_IDS.homogeneous])}>Resilient Sheet <span>&#8250;</span></button></li>
                  {/* <li><button type="button" onClick={handleSubMenuTabSelect('TILE',8092)}>TILE (coming soon) <span>&#8250;</span></button></li> */}
              </ul>
            </>
            ) : (
                <>
                    <p onClick={handleSubMenuBack} className={styles.modCarpet}> <span>&#8249;</span> {activeSubMenuTab}</p>
                    {renderActiveSubMenuTab(activeSubMenuTab,colorwaySeriesIds)}
                </>
            )}
        </>
    );


}